import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-version-info',
  imports: [],
  templateUrl: './version-info.component.html',
  styleUrl: './version-info.component.scss'
})
export class VersionInfoComponent {
  #versionService = inject(VersionService);

  applyCustomClass = input<boolean>(false);

  versionInfo = toSignal(this.#versionService.getVersionInfo(), { initialValue: null });
}
